import { render, staticRenderFns } from "./SingleUserStats.vue?vue&type=template&id=4376cb81"
import script from "./SingleUserStats.vue?vue&type=script&lang=js"
export * from "./SingleUserStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports